<template>
  <div
    id="main-grid"
    class="grid simple main borderRadius4px"
    style="background: #e5e9ec"
  >
    <div style="background: #e5e9ec">
      <!-- form -->
      <div
        class="grid-body no-border borderBottom"
        style="padding-left: 0px !important; padding-bottom: 0px !important;"
      >
        <h6>{{ i18nValues["harvest"] }}</h6>
        <el-form
          v-loading="loading != 0"
          :model="harvest"
          ref="form"
          :rules="rules"
        >
          <div
            class="flex-container"
            style="display: flex; flex-wrap: wrap; align-items: center;  margin-bottom: 14px"
          >
            <!-- Date -->
            <el-form-item prop="date">
              <template v-if="mode !== 'view'">
                <div
                  class="input-group"
                  style="width: 150px; margin-right: 10px;"
                >
                  <el-date-picker
                    type="date"
                    class="calendar"
                    format="dd/MM/yyyy"
                    v-model="harvest.date"
                    :placeholder="i18nValues['date']"
                  >
                  </el-date-picker>
                  <span class="input-group-addon primary el-input__suffix icon">
                    <span class="arrow"></span>
                    <i class="fa fa-calendar-alt"></i>
                  </span>
                </div>
              </template>
            </el-form-item>

            <!-- Harvest Quantity -->
            <el-form-item prop="quantity">
              <template v-if="mode !== 'view'">
                <el-input
                  v-model="harvest.quantity"
                  :placeholder="i18nValues['quantityInKg']"
                  style="width: 140px; margin-right: 10px;"
                  @input="validateNumber"
                ></el-input>
              </template>
            </el-form-item>

            <!-- Harvest Destination -->
            <el-form-item prop="destination">
              <template v-if="mode !== 'view'">
                <el-select
                  v-model="harvest.destination"
                  :placeholder="i18nValues['destination']"
                  style="width: 121px; margin-right: 10px;"
                  filterable
                >
                  <el-option
                    v-for="item in destinations"
                    :key="item.id"
                    :label="item.name"
                    :value="item.name"
                  >
                  </el-option>
                </el-select>
              </template>
            </el-form-item>

            <!-- Harvest Documnet Associated Trns -->
            <el-form-item prop="transportAssociatedDocument">
              <template v-if="mode !== 'view'">
                <el-input
                  v-model="harvest.transportAssociatedDocument"
                  :placeholder="i18nValues['transportAssociatedDocument']"
                  style="width: 320px; margin-right: 10px;"
                ></el-input>
              </template>
            </el-form-item>

            <!-- HA Amount Harvested -->
            <el-form-item prop="haAmountHarvested">
              <template v-if="mode !== 'view'">
                <el-input
                  v-model="harvest.haAmountHarvested"
                  :placeholder="i18nValues['haAmount']"
                  type="number"
                  style="width: 210px; margin-right: 10px;"
                ></el-input>
              </template>
            </el-form-item>

            <!-- add button  -->
            <el-form-item>
              <template
                v-if="
                  mode !== 'view' &&
                    (cropProduction.status === 'toHarvest' ||
                      cropProduction.status === 'harvested')
                "
              >
                <el-button
                  v-if="!isEditing"
                  @click="add()"
                  icon="fas fa-plus"
                  id="addButton"
                  size="small"
                  class="btn-primary"
                >
                  {{ i18nValues["add"] }}
                </el-button>
              </template>
            </el-form-item>
          </div>

          <div
            class="buttons-container"
            style="display: flex; justify-content: flex-start; margin-top: 10px;"
          >
            <!-- save button  -->
            <el-form-item>
              <el-button
                v-if="isEditing"
                @click="save()"
                icon="fas fa-check"
                id="saveButton"
                size="small"
                class="btn-primary"
              >
                {{ i18nValues["save"] }}
              </el-button>
            </el-form-item>

            <div></div>

            <!-- cancel button  -->
            <el-form-item>
              <el-button
                v-if="isEditing"
                @click="cancel()"
                id="cancelButton"
                size="small"
                icon="fas fa-times"
                class="btn-cancel"
                style="margin-left:10px"
              >
                {{ i18nValues["cancel"] }}
              </el-button>
            </el-form-item>
          </div>

          <!-- table -->
          <el-form-item prop="harvests">
            <div class="table-container">
              <el-table
                :data="HarvestSubList"
                class="table table-hover table-striped"
                id="HarvestTable"
                :empty-text="i18nValues['noDataAvailable']"
                align="center"
              >
                <!-- Harvest Date -->
                <el-table-column
                  prop="date"
                  :label="i18nValues['date']"
                  :formatter="formatDateHarvest"
                  width="25"
                  align="center"
                ></el-table-column>

                <!-- Harvest Quantity -->
                <el-table-column
                  prop="quantity"
                  :label="i18nValues['quantityInKg']"
                  width="25"
                  align="right"
                ></el-table-column>

                <!-- Harvest Destination -->
                <el-table-column
                  prop="destination"
                  :label="i18nValues['destination']"
                  width="25"
                  align="left"
                ></el-table-column>

                <!-- Harvest Documnet -->
                <el-table-column
                  prop="transportAssociatedDocument"
                  :label="i18nValues['transportAssociatedDocument']"
                  width="25"
                  align="left"
                ></el-table-column>

                <!-- Ha Amount Harvested -->
                <el-table-column
                  prop="haAmountHarvested"
                  :label="i18nValues['haAmount']"
                  :formatter="formatDecimal"
                  width="25"
                  align="right"
                ></el-table-column>

                <!-- EDIT/DELETE -->
                <el-table-column width="10" align="right">
                  <template slot-scope="scope" v-if="mode !== 'view'">
                    <el-button
                      class="text-info"
                      icon="fas fa-edit"
                      size="small"
                      :title="i18nValues['edit']"
                      @click="edit(scope.row)"
                    ></el-button>

                    <el-button
                      class="text-danger"
                      icon="fas fa-times"
                      size="small"
                      :title="i18nValues['remove']"
                      @click="deleteHarvest(scope.row)"
                    ></el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div v-if="90 > 10" style="height: 15px"></div>
              <PaginationFunctional
                sublistName="HarvestSubList"
                :fullList="HarvestList"
                :tableSize="15"
                @paginationChange="paginationChange"
              />
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { sync, get } from "vuex-pathify"; // eslint-disable-line no-unused-vars
import PaginationFunctional from "@/components/PaginationFunctional.vue";
export default {
  name: "Harvest",
  created() {
    if (this.cropProduction.id != 0) {
      this.retrieveHarvestList();
    }

    this.rules = {
      date: [
        {
          required: true,
          message: this.i18nValues["requiredValue"],
          trigger: "blur",
        },
      ],
      quantity: [
        {
          required: true,
          message: this.i18nValues["requiredValue"],
          trigger: "blur",
        },
      ],
      destination: [
        {
          required: true,
          message: this.i18nValues["requiredValue"],
          trigger: "change",
        },
      ],
      haAmountHarvested: [
        {
          validator: (rule, value, callback) => {
            if (this.isValidValue(value) && value) {
              callback(
                new Error(
                  `No puede ser superior a ${this.cropProduction.has -
                    this.currentValue} hectareas`
                )
              );
            } else {
              callback();
            }
          },
          trigger: "blur",
        },
      ],
    };
  },

  components: {
    PaginationFunctional,
  },

  computed: {
    loading: get("campaign/loading"),
  },

  props: {
    componentsMap: {},
    cropProduction: Object,
    mode: String,
    destinations: Array,
  },

  data() {
    return {
      harvest: {},
      HarvestList: [],
      HarvestSubList: [],
      isEditing: false,
      editingIndex: -1,
      currentValue: 0,
    };
  },

  methods: {
    add() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if (
            isNaN(Number(this.harvest.haAmountHarvested)) ||
            this.harvest.haAmountHarvested === ""
          ) {
            this.harvest.haAmountHarvested = 0;
          }
          this.HarvestList.push(this.harvest);
          this.cropProduction.qtyRealHarvest = parseInt((this.cropProduction.qtyRealHarvest !== null ? this.cropProduction.qtyRealHarvest : 0)) + parseInt(this.harvest.quantity);
          this.harvest = {};
          this.cropProduction.harvests = this.HarvestList;
          this.calculateCurrentValue();
          this.sortHarvestList();
        }
      });
    },

    retrieveHarvestList() {
      this.HarvestList = this.cropProduction.harvests;
      this.currentValue = this.HarvestList.reduce((total, harvest) => {
        return total + harvest.haAmountHarvested;
      }, 0);

      this.sortHarvestList();
    },

    sortHarvestList() {
      this.HarvestList.sort((a, b) => {
        return new Date(b.date) - new Date(a.date);
      });
    },

    deleteHarvest(row) {
      this.$confirm(
        this.i18nValues["deleteHarvestMessage"],
        this.i18nValues["deleteHarvest"],
        {
          distinguishCancelAndClose: true,
          confirmButtonText: "Eliminar",
          cancelButtonText: "Cancelar",
          type: "warning",
        }
      ).then(() => {
        this.cropProduction.qtyRealHarvest = this.cropProduction.qtyRealHarvest - row.quantity;
        this.HarvestList.splice(this.HarvestList.indexOf(row), 1);
        this.harvest = {}
        this.calculateCurrentValue();
      });
      
    },

    edit(row) {
      this.isEditing = true;
      this.editingIndex = this.HarvestList.indexOf(row);
      this.harvest = JSON.parse(JSON.stringify(row));
    },

    save() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if (this.editingIndex >= 0) {
            this.HarvestList.splice(this.editingIndex, 1, this.harvest);
            this.editingIndex = -1;
            this.harvest = {};
            this.isEditing = false;
          }
        }
      });
    },

    cancel() {
      this.harvest = {};
      this.isEditing = false;
    },

    formatDateHarvest(row) {
      return this.formatDate(row.date);
    },

    formatDecimal(row, column, cellValue) {
      return new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(cellValue);
    },

    validateNumber() {
      this.harvest.quantity = this.harvest.quantity.replace(/\D/g, "");
    },

    calculateCurrentValue() {
      this.currentValue = this.HarvestList.reduce(
        (total, harvest) => total + Number(harvest.haAmountHarvested),
        0
      );
    },

    isValidValue(value) {
      const numericValue = isNaN(Number(value)) ? 0 : Number(value);
      return this.currentValue + numericValue > this.cropProduction.has;
    },
  },
};
</script>

<style scoped>
.input-container {
  align-items: center;
}

.input-container > * {
  margin-right: 10px;
}

.table-container {
  margin-left: 0;
}
</style>
